module.exports = __webpack_public_path__ + "fonts/CRC55.f2795b85.ttf";